export default __webpack_public_path__ + "static/media/yatnal.9e5c1743.jpg";